import { Component, Fragment, h } from 'preact';
import * as appStyles from '../../assets/global.scss';
import { withStyles, WithStyles } from '../../style';
import { getKey, AmPaxAmount, Key, PaxAmount, Properties, WidgetTab, AmRooms, TravelClass } from '../../common';
import Selector from '../../common/Selector/Selector';
import { BookingState, connectStore } from '../../store';
import { stopPropagation } from '../../utils';
import AmPaxAmountModal from './Modal/AmPaxAmountModal/AmPaxAmountModal';
import PaxAmountModal from './Modal/PaxAmountModal/PaxAmountModal';
import { PaxAmountDetails, PaxAmountType } from './PaxAmountDetails/PaxAmountDetails';
import { FinText } from '../../i18n';
import Icon from '../../common/Icon/Icon';

export interface PaxAmountSelectorProps extends Properties {}

interface StoreProps {
  paxAmount: PaxAmount;
  amRooms: AmRooms;
  am: boolean;
  enableCompactWidget: boolean;
  travelClass: TravelClass;
}

type EffectiveProps = PaxAmountSelectorProps & StoreProps & WithStyles;

const mapStateToProps = ({
  selection: { paxAmount, travelClass },
  amState: {
    amSelection: { rooms },
  },
  currentTab,
  enableCompactWidget,
}: BookingState): StoreProps => ({
  paxAmount,
  am: currentTab === WidgetTab.AM,
  amRooms: rooms, // TODO #am remove
  enableCompactWidget,
  travelClass: currentTab === WidgetTab.AM ? TravelClass.MIXED : travelClass,
});

@withStyles(appStyles)
@connectStore({ mapStateToProps })
export default class PaxAmountSelector extends Component<PaxAmountSelectorProps> {
  openModal = (e: Event): void => {
    stopPropagation(e);
    const modal = (this.props as EffectiveProps).am ? <AmPaxAmountModal /> : <PaxAmountModal />;
    this.context.modal.showModal(modal);
  };

  handleKeyUp = (e: KeyboardEvent): void => {
    const key: Key = getKey(e);
    if (key === Key.ENTER || key === Key.SPACE) {
      this.openModal(e);
    }
  };

  render({ paxAmount, am, amRooms, enableCompactWidget, travelClass, tx }: EffectiveProps): h.JSX.Element {
    return (
      <Selector class={this.props.class} onClick={this.openModal} onKeyUp={this.handleKeyUp}>
        <div class="grey-600-text font-body-1 regular-type">
          <FinText id={enableCompactWidget && !am ? 'paxAndClassSelector.label' : 'paxAmountSelector.title'} />
        </div>
        <div
          class={tx('nordic-blue-900-text font-heading-5 medium-type', {
            'flex flex--middle': enableCompactWidget,
          })}
        >
          {enableCompactWidget && <Icon iconName="multi-pax" class="is-xxsmall flex--nogrow" />}
          <PaxAmountDetails
            type={enableCompactWidget && !am ? PaxAmountType.NUMBER : PaxAmountType.DETAILED}
            paxAmount={am ? toPaxAmount(amRooms) : paxAmount}
          />
          {enableCompactWidget && !am && (
            <Fragment>
              {', '}
              <FinText id={`travelClass.${travelClass === TravelClass.MIXED ? 'mixedCombined' : travelClass}`} />
            </Fragment>
          )}
        </div>
      </Selector>
    );
  }
}

const toPaxAmount = (rooms: AmRooms): PaxAmount => {
  return {
    adults: rooms.reduce((mem: number, { adults }: AmPaxAmount): number => mem + adults, 0),
    children: rooms.reduce((mem: number, { children }) => mem + children, 0),
    infants: 0,
    c15s: 0,
  };
};
